(function () {
  const STORAGE_KEY = "stored_params";
  const LAST_SENT_KEY = "last_sent_params";

  // ✅ FIX 1: Whitelist only tracking params
  const ALLOWED_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid", "event"];

  // ✅ FIX 5: Guard against parallel cart update calls
  let isUpdatingCart = false;

  /* STORE + MERGE PARAMS */
  (function storeParams() {
    const urlParams = new URLSearchParams(window.location.search);

    let existing = {};

    try {
      existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {}

    urlParams.forEach((value, key) => {
      // ✅ FIX 1: Only store whitelisted params
      if (value && ALLOWED_PARAMS.includes(key)) {
        existing[key] = value;
      }
    });

    if (Object.keys(existing).length) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    }
  })();

  /* HELPERS */
  function getStoredParams() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function isValidLink(href) {
    return href &&
      !href.startsWith("#") &&
      !href.startsWith("mailto:") &&
      !href.startsWith("tel:") &&
      !href.startsWith("javascript:");
  }

  function isShopifyCartLink(url) {
    return url.pathname === "/cart" || url.pathname.startsWith("/cart?");
  }

  // ✅ FIX 2: Exclude Colissimo, checkout, and relay links
  function isSafeToAppend(url) {
    const excluded = [
      "/checkout",
      "/apps/",
      "/tools/",
      "colissimo",
      "so-colissimo",
      "boxtal",
      "relay",
      "pickup",
      "livraison",
      "point-relais",
      "widget"
    ];
    return !excluded.some(path =>
      url.pathname.includes(path) || url.href.includes(path)
    );
  }

  /* UPDATE CART ATTRIBUTES ONLY */
  function updateCartAttributes() {
    // ✅ FIX 5: Prevent parallel calls
    if (isUpdatingCart) return;

    const params = getStoredParams();

    if (!Object.keys(params).length) return;

    let lastSent = {};

    try {
      lastSent = JSON.parse(sessionStorage.getItem(LAST_SENT_KEY)) || {};
    } catch (e) {}

    if (JSON.stringify(params) === JSON.stringify(lastSent)) {
      return;
    }

    isUpdatingCart = true; // ✅ FIX 5: Lock

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (!cart || !cart.items || !cart.items.length) return;

        // ✅ FIX 3: Only send whitelisted params to cart attributes
        const safeParams = {};
        ALLOWED_PARAMS.forEach(key => {
          if (params[key]) safeParams[key] = params[key];
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: safeParams
          })
        }).then(() => {
          sessionStorage.setItem(LAST_SENT_KEY, JSON.stringify(params));
        });
      })
      .catch(err => console.warn("Cart update error:", err))
      .finally(() => {
        isUpdatingCart = false; // ✅ FIX 5: Unlock
      });
  }

  /* POLL AFTER ADD TO CART */
  function pollAndUpdateCart(attemptsLeft) {
    if (attemptsLeft <= 0) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (cart && cart.items && cart.items.length) {
          updateCartAttributes();
        } else {
          setTimeout(() => pollAndUpdateCart(attemptsLeft - 1), 800);
        }
      })
      .catch(() => {});
  }

  /* ADD TO CART DETECTION */
  document.addEventListener('submit', function (e) {
    if (
      e.target.action &&
      e.target.action.includes('/cart/add')
    ) {
      pollAndUpdateCart(5);
    }
  }, true);

  /* AJAX ADD TO CART SUPPORT */
  const originalFetch = window.fetch;

  window.fetch = function(url, options) {
    const result = originalFetch.apply(this, arguments);

    if (
      typeof url === 'string' &&
      url.includes('/cart/add')
    ) {
      result
        .then(() => pollAndUpdateCart(5))
        .catch(() => {});
    }

    return result;
  };

  /* CART PAGE LOAD */
  if (window.location.pathname === "/cart") {
    updateCartAttributes();
  }

  /* CLICK-BASED PARAM APPEND */
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a");

    if (!link) return;

    const href = link.getAttribute("href");

    if (!isValidLink(href)) return;

    const params = getStoredParams();

    if (!Object.keys(params).length) return;

    try {
      const url = new URL(href, window.location.origin);

      // ✅ FIX 2: Skip Colissimo/checkout links entirely
      if (!isSafeToAppend(url)) return;

      Object.keys(params).forEach(key => {
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, params[key]);
        }
      });

      if (isShopifyCartLink(url)) {
        link.href = url.toString();
        return;
      }

      // ✅ FIX 4: Respect target="_blank" links
      if (link.target === "_blank") {
        link.href = url.toString();
        return;
      }

      e.preventDefault();
      window.location.href = url.toString();

    } catch (err) {
      console.warn("Param append error:", err);
    }

  }, true);

})();